import React, { useCallback, useContext, useEffect, useMemo } from "react";
import "./index.css"
import { QuestionarioContext } from "../../../../contexts/QuestionarioContext";
import { PerguntaContext } from "../../../../contexts/PerguntaContext";
import QuestionarioService from "../../../../services/QuestionarioService";
import { trackPromise } from "react-promise-tracker";
import { successToast } from "../../../../components/DommusToast";
import Swal from "sweetalert2";
import { Button, Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import DommusRequiredSpan from "../../../../components/DommusRequiredSpan";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faSave } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import DommusSwitchControl from "../../../../components/DommusSwitchControl";
import { Controller, useForm } from "react-hook-form";

export function QuestionarioForm({
    questionario,
    closeModal,
}) {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        setValue,
        getValues,
        watch
    } = useForm({
        defaultValues: questionario,
    });
    const permiteEnvioWatch = watch('permite_envio_corpo_template');
    const habilitaComentarioWatch = watch('habilita_comentario');
    const { adicionarQuestionario, atualizarQuestionario } = useContext(QuestionarioContext);
    const { listaPerguntas } = useContext(PerguntaContext);

    const isUpdate = useMemo(() => {
        return Boolean(Object.keys(questionario).length);
    }, [questionario]);

    const handleOnSubmit = (data) => {
        data.perguntas = data.perguntas?.length
            ? (data.perguntas.map((pergunta) => {
                return pergunta.value;
            }))
            : [];


        data.empreendimentos_vinculados = data?.empreendimentos_vinculados?.map((item) => {
            return item.value;
        })

        if(isUpdate){
          delete data.perguntas;
        }

        let metodo = isUpdate
            ? QuestionarioService.update(questionario.id_questionario, data)
            : QuestionarioService.store(data);

        trackPromise(metodo).then((response) => {
            if (isUpdate) {
                atualizarQuestionario(response.data);
            } else {
                adicionarQuestionario(response.data);
            }
            successToast.fire("Questionário salvo com sucesso!!");
            closeModal();
        })
            .catch((error) => {
                Swal.fire({
                    titleText: "Ooops...",
                    text:
                        "Ocorreu um erro ao tentar salvar um novo questionário: " + (error?.response?.data?.descricao ?? error),
                    icon: "error",
                });
            });
    };

    const perguntasOptions = useMemo(() => {
        return listaPerguntas.length
            ? listaPerguntas.map((pergunta) => {
                return { value: pergunta.id_pergunta, label: pergunta.enunciado };
            })
            : [];
    }, [listaPerguntas]);

    return (
        <Form onSubmit={handleSubmit(handleOnSubmit)} className="questionario-form">
            <Row>
                <Col md="12">
                    <Form.Label>
                        Nome:
                        <DommusRequiredSpan />
                    </Form.Label>
                    <Form.Control
                        type="text"
                        {...register('descricao', { required: true })}
                    />
                    {errors.descricao && (
                        <small className="form-text text-danger">Campo Obrigatório*</small>
                    )}
                </Col>
            </Row>
            <Row>
                <Col md="12" className="mt-3">
                    <Form.Label>
                        Descrição:
                    </Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={4}
                        {...register('mensagem', { required: true })}
                    />
                </Col>
            </Row>
            {isUpdate ? (
                <></>
            ) : (
                <Row>
                    <Col md="12" className="mt-3">
                        <Form.Label>Perguntas:</Form.Label>
                        <Controller
                          name="perguntas"
                          control={control}
                          render={({ field }) => (
                              <Select
                                  {...field}
                                  isMulti
                                  options={perguntasOptions}
                                  onChange={(selected) => field.onChange(selected)}
                                  value={field.value}
                              />
                          )}
                        />
                    </Col>
                </Row>
            )}
            <Row>
              <Col md="12" className="mt-2 mb-2 d-flex align-items-center">
                <Controller
                  name="habilita_comentario"
                  control={control}
                  render={({onChange, value})=>(
                    <DommusSwitchControl
                        labelInativo="Habilitar comentário"
                        checked={Number(habilitaComentarioWatch)}
                        tooltip={Number(habilitaComentarioWatch) ? 'Sim' : 'Não'}
                        labelAtivo=""
                        onChange={(event)=>{
                          setValue('habilita_comentario', event?.target?.checked ? '1' : '0')
                        }}
                    />
                  )}
                />
                <OverlayTrigger
                  key="questionario-comentario-habilita"
                  placement="right"
                  overlay={
                      <Tooltip
                          id={"questionario-comentario-habilita"}
                      >
                         Habilita uma caixa de comentário após a conclusão do questionário. 
                      </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faQuestionCircle}/>
                </OverlayTrigger>
              </Col>
            </Row>
            <Row>
              <Col md="12" className="mt-2 mb-2 d-flex align-items-center">
                <Controller
                  name="permite_envio_corpo_template"
                  control={control}
                  render={({onChange, value})=>(
                    <DommusSwitchControl
                        labelInativo="Permite o envio pelo corpo do e-mail"
                        checked={Number(permiteEnvioWatch)}
                        tooltip={Number(getValues('permite_envio_corpo_template')) ? 'Sim' : 'Não'}
                        labelAtivo=""
                        onChange={(event)=>{
                          setValue('permite_envio_corpo_template', event?.target?.checked ? '1' : '0')
                        }}
                    />
                  )}
                />
                <OverlayTrigger
                  key="questionario-embed"
                  placement="right"
                  overlay={
                      <Tooltip
                          id={"questionario-embed"}
                      >
                          Só será adicionado ao corpo da mensagem as perguntas que sejam dos tipo Checkbox, Simples seleção ou Radio button. Somente uma única pergunta será respondida.
                      </Tooltip>
                  }

                >
                  
                  <FontAwesomeIcon icon={faQuestionCircle}/>
                </OverlayTrigger>
              </Col>
            </Row>
            <Row className="footer-modal-questionario">
                <Button variant="success" type="submit">
                    <FontAwesomeIcon icon={faSave} /> Salvar
                </Button>
            </Row>
        </Form>
    );
}
